import 'react-tooltip/dist/react-tooltip.css'
import IonIcon from '@reacticons/ionicons'
const InfoIconWithToolTip = ({
  id = 'my-tooltip',
  content,
  place = 'top',
  className = ''
}) => {
  return (
    <IonIcon
      name='information-circle-outline'
      className={`text-[15px] cursor-pointer ${className}`}
      data-tooltip-id={id}
      data-tooltip-content={content}
      data-tooltip-place={place}
    />
  )
}

export default InfoIconWithToolTip
